;(function($, window, document) {

    "use strict";

    $(document).ready(function() {
        console.log('tets');
    });

})(jQuery, window, document);